// extracted by mini-css-extract-plugin
export default {"section":"Offer_section__0aIwj","stage":"Offer_stage__Xn69k","title":"Offer_title__wVL1T","text":"Offer_text__pmlXc","purpleButton":"Offer_purpleButton__8UttN"};